import AjaxRequest from "../modules/ajax-request";

class NewsletterUnsubscribe {
    constructor(element) {
        this.div = element;
        this.ajaxCallData = {};
        this.ajaxCallTokenData = {};

        this.init();
        this.getData();
        this.clearData();
        this.bindEvents();
    }

    init() {
        this.loadingElement = this.div.querySelector(".add-load-element");
        this.form = this.div.querySelector("[data-id='widget-newsletter-unsubscribe__form']");
        this.formWrapper = this.div.querySelector("[data-id='widget-newsletter-unsubscribe__form-wrapper']");
        this.formFeedback = this.form.querySelector('[data-id="widget-newsletter-unsubscribe__form-feedback"]');
    }

    getData() {
        const d = this.div.dataset;
        [
            this._id,
            this.ajaxCallData.url,
            this.ajaxCallData.controller,
            this.ajaxCallData.action,
            this.ajaxCallData.method,
            this.ajaxCallData.parameters,
            this.ajaxCallData.payload,
            this.ajaxCallData.signature,
            this.ajaxCallTokenData.url,
            this.ajaxCallTokenData.controller,
            this.ajaxCallTokenData.action,
            this.ajaxCallTokenData.method,
            this.ajaxCallTokenData.parameters,
            this.ajaxCallTokenData.payload,
            this.ajaxCallTokenData.signature
        ] = Object.values(d);
    }

    clearData() {
        Array.from(this.div.attributes)
            .filter(attr => attr.name.startsWith("data-"))
            .forEach(attr => this.div.removeAttribute(attr.name));
    }

    bindEvents() {
        this.div.addEventListener("submit", (event) => {
            if (event.target.matches("[data-id='widget-newsletter-unsubscribe__form']")) {
                this.submitForm(event);
            }
        });

        this.div.addEventListener("submit", (event) => {
            if (event.target.matches("[data-id='widget-newsletter-unsubscribe__token-form']")) {
                this.submitTokenForm(event);
            }
        });
    }

    submitForm(event) {
        event.preventDefault();

        this.formFeedback.classList.remove("is-success", "is-failure");
        this.formFeedback.innerHTML = "";

        const formData = Object.fromEntries(new FormData(this.form));
        const ajaxRequest = new AjaxRequest({
            elementToAddLoading: this.loadingElement,
            successCallback: (response) => {
                this.formWrapper.outerHTML = response.message;
            },
            errorCallback: (response) => {
                this.formFeedback.classList.add("is-failure");
                this.formFeedback.innerHTML = response.responseJSON.message;
            }
        });

        ajaxRequest.makeCall(this.ajaxCallData.url, {
            controller: this.ajaxCallData.controller,
            action: this.ajaxCallData.action,
            method: this.ajaxCallData.method,
            _parameters: this.ajaxCallData.parameters,
            payload: this.ajaxCallData.payload,
            signature: this.ajaxCallData.signature,
            ...formData,
        });
    }

    submitTokenForm(event) {
        event.preventDefault();

        const _tokenForm = this.div.querySelector("[data-id='widget-newsletter-unsubscribe__token-form']");
        const _formFeedback = _tokenForm.querySelector('[data-id="widget-newsletter-unsubscribe__token-form-feedback"]');

        _formFeedback.classList.remove("is-success", "is-failure");
        _formFeedback.innerHTML = "";

        const formData = Object.fromEntries(new FormData(_tokenForm));
        const ajaxRequest = new AjaxRequest({
            elementToAddLoading: this.loadingElement,
            successCallback: (response) => {
                _formFeedback.classList.add("is-success");
                _formFeedback.innerHTML = response.message;
            },
            errorCallback: (response) => {
                _formFeedback.classList.add("is-failure");
                _formFeedback.innerHTML = response.responseJSON.message;
            }
        });

        ajaxRequest.makeCall(this.ajaxCallTokenData.url, {
            controller: this.ajaxCallTokenData.controller,
            action: this.ajaxCallTokenData.action,
            method: this.ajaxCallTokenData.method,
            _parameters: this.ajaxCallTokenData.parameters,
            payload: this.ajaxCallTokenData.payload,
            signature: this.ajaxCallTokenData.signature,
            ...formData,
        });
    }
}

export default NewsletterUnsubscribe;